module.exports = __webpack_public_path__ + "img/logo_javer.fe232937.png";